// import React from "react";

// const Divider = ({
//   orientation = "horizontal", //vertical, horizontal
//   variant = "fullWidth",
//   children,
//   className = "",
//   textAlign = "center",
//   light = false,
//   flexItem = false, // Add flexItem prop
// }) => {
//   const orientationStyles = {
//     horizontal: "w-full border-t",
//     vertical: "h-auto self-stretch border-l inline-block", // Updated vertical style
//   };

//   const variantStyles = {
//     fullWidth: "",
//     inset: "mx-16",
//     middle: "mx-8",
//   };

//   const textAlignStyles = {
//     center: "text-center",
//     left: "text-left",
//     right: "text-right",
//   };

//   if (children) {
//     return (
//       <div
//         className={`flex items-center ${
//           flexItem ? "flex-[0_0_auto]" : ""
//         } ${className}`}
//       >
//         <div
//           className={`flex-grow border-t ${
//             light ? "border-gray-200" : "border-gray-300"
//           } ${variantStyles[variant]}`}
//         />
//         <span className={`px-4 ${textAlignStyles[textAlign]} select-none`}>
//           {children}
//         </span>
//         <div
//           className={`flex-grow border-t ${
//             light ? "border-gray-200" : "border-gray-300"
//           } ${variantStyles[variant]}`}
//         />
//       </div>
//     );
//   }

//   return (
//     <hr
//       className={`
//         ${orientationStyles[orientation]}
//         ${variantStyles[variant]}
//         ${light ? "border-gray-200" : "border-gray-300"}
//         ${flexItem ? "flex-[0_0_auto]" : ""}
//         ${className}
//       `}
//     />
//   );
// };

// export default Divider;

import React from "react";

const Divider = ({
  orientation = "horizontal", // "vertical" | "horizontal"
  variant = "fullWidth", // "fullWidth" | "inset" | "middle"
  children,
  className = "",
  textAlign = "center", // "center" | "left" | "right"
  light = false,
  flexItem = false,
}) => {
  const orientationStyles = {
    horizontal: "w-full border-t",
    vertical: "h-auto self-stretch border-l inline-block",
  };

  const variantStyles = {
    fullWidth: "",
    inset: "mx-16",
    middle: "mx-8",
  };

  const baseLine = `border-t ${light ? "border-gray-200" : "border-gray-300"} ${
    variantStyles[variant]
  }`;

  // For labeled dividers, control how much space each line takes.
  // - center: both sides grow equally
  // - left:   left side is a short stub, right side grows
  // - right:  right side is a short stub, left side grows
  const leftLineGrow = textAlign === "left" ? "shrink-0 w-6" : "flex-grow";
  const rightLineGrow = textAlign === "right" ? "shrink-0 w-6" : "flex-grow";

  if (children && orientation === "horizontal") {
    return (
      <div
        role="separator"
        aria-orientation="horizontal"
        className={`flex items-center w-full ${
          flexItem ? "flex-[0_0_auto]" : ""
        } ${className}`}
      >
        <div className={`${baseLine} ${leftLineGrow}`} />
        <span className="px-4 select-none">{children}</span>
        <div className={`${baseLine} ${rightLineGrow}`} />
      </div>
    );
  }

  // Fallback (no children) or vertical divider
  return (
    <hr
      role="separator"
      aria-orientation={orientation}
      className={`
        ${orientationStyles[orientation]}
        ${variantStyles[variant]}
        ${light ? "border-gray-200" : "border-gray-300"}
        ${flexItem ? "flex-[0_0_auto]" : ""}
        ${className}
      `}
    />
  );
};

export default Divider;
